<template>
  <b-dropdown
    v-if="listActions.length"
    variant="link"
    toggle-class="p-0"
    no-caret
    right
  >
    <template #button-content>
      <feather-icon
        icon="MoreVerticalIcon"
        size="16"
        class="align-middle text-body"
      />
    </template>
    <b-dropdown-item
      v-for="(item, index) in listActions"
      :key="`item-action-${index}`"
      @click="item.action(data.item)"
    >
      <feather-icon :icon="item.icon" />
      <span class="align-middle ml-50">{{ item.title }}</span>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import {
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import get from 'lodash/get'

export default {
  components: {
    BDropdown,
    BDropdownItem,
  },
  props: {
    actions: {
      type: Array,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    listActions() {
      const listCanAccess = this.actions.filter(el => el.access !== false)

      return listCanAccess.map(el => {
        let haveTo = ''
        if (el.to) {
          let rawParmas = []
          let rawQuery = []

          const routeTo = el.to.split('|')

          if (routeTo.length > 1) {
            rawParmas = routeTo[1].split(',')
              .map(ex => {
                const hh = ex.split(':')
                return { [hh[0]]: get(this.data.item, hh[1]) }
              })
          }

          if (routeTo.length > 2) {
            rawQuery = routeTo[2].split(',')
              .map(ex => {
                const hh = ex.split(':')
                return { [hh[0]]: get(this.data.item, hh[1]) ? get(this.data.item, hh[1]) : hh[1] }
              })
          }

          haveTo = {
            name: routeTo[0],
            params: Object.assign({}, ...rawParmas),
            query: Object.assign({}, ...rawQuery),
          }
        }

        return {
          ...el,
          action: el.to ? () => { this.$router.push(haveTo) } : el.action,
        }
      })
    },
  },
}
</script>
